import moment from 'moment';

export const blockedNumbersHashMap = (state) => {
  return _.keyBy(_.filter(state.blockedNumbers, function(bn) {
    return !bn.timeLimited || moment(bn.expiration).diff(moment()) > 0;
  }), function(blockedNumber) {
    return blockedNumber.phoneNumber;
  });
};